"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var PutBucketNotificationInput_1 = require("./PutBucketNotificationInput");
var PutBucketNotificationOutput_1 = require("./PutBucketNotificationOutput");
var ServiceMetadata_1 = require("./ServiceMetadata");
exports.PutBucketNotification = {
    metadata: ServiceMetadata_1.ServiceMetadata,
    name: "PutBucketNotification",
    http: {
        method: "PUT",
        requestUri: "/{Bucket}?notification"
    },
    input: {
        shape: PutBucketNotificationInput_1.PutBucketNotificationInput
    },
    output: {
        shape: PutBucketNotificationOutput_1.PutBucketNotificationOutput
    },
    errors: []
};
//# sourceMappingURL=PutBucketNotification.js.map